'use strict';

/**
 * ユーザエージェントからスマホかとかAndroidかを判別するライブラリ
 */
export default {
  /**
   * ブラウザの言語からenかjaかを返す
   * @returns {boolean}
   */
  getLang(){
    try{
      let lang = (navigator.browserLanguage || navigator.language || navigator.userLanguage).substr(0, 2);
      if(lang !== 'ja'){
        return 'en';
      }
      else{
        return 'ja';
      }
    }
    catch(e){
      return 'ja';
    }
  }
};



// WEBPACK FOOTER //
// ./src/libs/lang.js